import React, { useState } from "react";
import { AiOutlineCheckSquare } from "react-icons/ai";
import { RxCrossCircled } from "react-icons/rx";
// import ScrollTrigger from "react-scroll-trigger";

const Plans = () => {
  // const [animationOn, setAnimationOn] = useState(false);

  return (
    <div className="plans">
      <h1 style={{ marginBottom: "12px" }} className="mainHeading">
        Pricing
      </h1>
      <p className="mainPara">Choose the Plan</p>
      <div className="plansContent">
            <div className="plan animate__animated animate__fadeInLeft">
              <h3 className="planName">Silver</h3>
              <h1 className="planPrice">$29.99</h1>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi
                amet,
              </p>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Landing Page</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Logo Design</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Featured</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Responsive Design</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Email Support</span>
              </div>
              <div className="planService">
                <RxCrossCircled className="planIcon" />
                <span>SEO Optimation</span>
              </div>
              <div className="planService">
                <RxCrossCircled className="planIcon" />
                <span>Source Code</span>
              </div>
              <div className="planService">
                <RxCrossCircled className="planIcon" />
                <span>E Commerce</span>
              </div>
              <div className="planService">
                <RxCrossCircled className="planIcon" />
                <span>Content Upload</span>
              </div>
              <div className="planBtnDiv">
                <button className="planBtn mainBtn">Purchase</button>
              </div>
            </div>
            <div className="plan animate__animated animate__fadeInUp">
              <h3 className="planName">Silver</h3>
              <h1 className="planPrice">$69.99</h1>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi
                amet,
              </p>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Business Website</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Logo Design</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Featured</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Responsive Design</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Email Support</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>SEO Optimation</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Source Code</span>
              </div>
              <div className="planService">
                <RxCrossCircled className="planIcon" />
                <span>E Commerce</span>
              </div>
              <div className="planService">
                <RxCrossCircled className="planIcon" />
                <span>Content Upload</span>
              </div>
              <div className="planBtnDiv">
                <button className="planBtn mainBtn">Purchase</button>
              </div>
            </div>
            <div className="plan animate__animated animate__fadeInRight">
              <h3 className="planName">Silver</h3>
              <h1 className="planPrice">$149.99</h1>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi
                amet,
              </p>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>E Commerce Website</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Logo Design</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Featured</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Responsive Design</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Email Support</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>SEO Optimation</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Source Code</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>E Commerce</span>
              </div>
              <div className="planService">
                <AiOutlineCheckSquare className="planIcon" />
                <span>Content Upload</span>
              </div>
              <div className="planBtnDiv">
                <button className="mainBtn planBtn">Purchase</button>
              </div>
            </div>
      </div>
    </div>
  );
};

export default Plans;
